import { EType } from '../repositories/journal/entities/journal/ArticlesMainAttributesSchema';

export const ListingItemType = {
  [EType.Articles]: 'http://schema.org/Article',
  [EType.Blogs]: 'http://schema.org/Article',
  [EType.Questions]: 'http://schema.org/Article',
  [EType.Quizzes]: 'http://schema.org/Article',
  [EType.News]: 'http://schema.org/NewsArticle',
};
